import React from "react";
import { TableBody, TableCell} from "@material-ui/core";
import { formatCurrency } from "../../../utils/Utils";
import {
  DashboardTableContainer,
  DashboardTableStyled,
  DashboardTableRow,
  TableHeaderText,
  TableBodyText,
} from "./DashboardTableStyles";

export default ({ premiums, claims, incomes, expenses }) => {
  const rows = [
    { title: "Total Premiums Received", amount: premiums },
    { title: "Total Claims Payed Out", amount: claims },
    { title: "Total Income", amount: incomes },
    { title: "Total Expenses", amount: expenses },
  ];

  return (
    <DashboardTableContainer>
      <DashboardTableStyled aria-label="simple table">
        <TableBody>
          {rows.map((row) => (
            <DashboardTableRow key={row.title}>
              <TableCell component="th" scope="row">
                <TableHeaderText>{row.title}</TableHeaderText>
              </TableCell>
              <TableCell align="right">
                <TableBodyText>
                  R {formatCurrency(parseFloat(row.amount).toFixed(2))}
                </TableBodyText>
              </TableCell>
            </DashboardTableRow>
          ))}
        </TableBody>
      </DashboardTableStyled>
    </DashboardTableContainer>
  );
};
